// Licht-Choreografie + Dark→Light-Theme-Switch.
//
// Farbwechsel ausschließlich über das Element „Farbwechsel“ (Blueprint
// themeSwitchMarker, unsichtbar, frei im CMS platzierbar). Jeder Marker legt
// fest, welches Theme ab seiner Position gilt (hell/dunkel). Maßgeblich ist der
// letzte Marker, der die Viewport-Mitte erreicht hat; davor gilt dunkel.
// Ohne Marker auf der Seite findet kein Farbwechsel statt.
//
// Licht-Sequenz der lightFontAnimation, sobald sie die Viewport-Mitte erreicht:
//   1. sofort:   Zeile 1 ("Licht") leuchtet ein            -> .is-lit-1
//   2. ~1400ms:  restliche Zeilen ("das Atmosphäre schafft") -> .is-lit-2
// Scrollt man wieder unter das Trigger-Band zurueck, wird alles zurueckgesetzt
// und die Sequenz spielt beim naechsten Mal neu. Liegt die Sektion bereits
// oberhalb der Mitte (Deep-Link/Reload weiter unten oder Sprung per
// PageDown/Ende/Scrollbar), wird der Endzustand ohne Verzoegerung gesetzt.
//
// Mechanik: positionsbasierter Check pro Scroll-Frame statt IntersectionObserver
// — ein IO mit schmalem Root-Band feuert nicht, wenn ein grosser Scrollsprung
// (PageDown, Ende-Taste, Scrollbar-Drag) das Band komplett ueberspringt; der
// Text bliebe dann unsichtbar und das Theme falsch.

const LIGHT_CLASS = 'light';
const REST_DELAY_MS = 1400;

// Band: mittlere ~10% des Viewports.
function bandPosition(el) {
  const rect = el.getBoundingClientRect();
  const bandTop = window.innerHeight * 0.45;
  const bandBottom = window.innerHeight * 0.55;
  if (rect.top < bandBottom && rect.bottom > bandTop) {
    return 'in';
  }
  return rect.top < bandTop ? 'past' : 'before';
}

function createLightSequence(section, reduceMotion) {
  // Erst jetzt verstecken (CSS: .is-armed) — ohne JS bleibt der Text sichtbar.
  section.classList.add('is-armed');

  let timers = [];
  let active = false;

  const clearTimers = () => {
    timers.forEach((t) => clearTimeout(t));
    timers = [];
  };

  const play = (instant) => {
    if (active) {
      return;
    }
    active = true;
    clearTimers();

    if (instant || reduceMotion) {
      section.classList.add('is-lit-1', 'is-lit-2');
      return;
    }

    section.classList.add('is-lit-1');
    timers.push(setTimeout(() => section.classList.add('is-lit-2'), REST_DELAY_MS));
  };

  const reset = () => {
    if (!active) {
      return;
    }
    active = false;
    clearTimers();
    section.classList.remove('is-lit-1', 'is-lit-2');
  };

  return () => {
    const position = bandPosition(section);
    if (position === 'in') {
      play(false);
    } else if (position === 'past') {
      play(true);
    } else {
      reset();
    }
  };
}

function createMarkerSwitch(markers) {
  return () => {
    let theme = 'dark';
    markers.forEach((marker) => {
      if (bandPosition(marker) !== 'before') {
        theme = marker.dataset.themeSwitch === 'dark' ? 'dark' : 'light';
      }
    });
    document.body.classList.toggle(LIGHT_CLASS, theme === 'light');
  };
}

export function initThemeSwitch() {
  const markers = Array.from(document.querySelectorAll('.js-themeSwitchMarker'));
  const sections = Array.from(document.querySelectorAll('.lightFontAnimation'));
  if (!markers.length && !sections.length) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const updates = sections.map((section) => createLightSequence(section, reduceMotion));
  if (markers.length) {
    updates.push(createMarkerSwitch(markers));
  }

  const evaluate = () => updates.forEach((update) => update());

  let ticking = false;
  const requestEvaluate = () => {
    if (ticking) {
      return;
    }
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      evaluate();
    });
  };

  window.addEventListener('scroll', requestEvaluate, { passive: true });
  window.addEventListener('resize', requestEvaluate, { passive: true });
  evaluate();
}
